import { CancelRounded, CheckCircleRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../language/keys';
import { ProgressBar } from '../../ProgressBar';
import { MatchFlowStatusEnum } from '../../../../../../consts/enums';
import { style } from './style';

type RunStatusCompletedProps = {
  numberOfCreatedCandidates: number,
  duplicateCandidatesSkipped?: number,
  status: MatchFlowStatusEnum,
}

export const RunStatusCompleted = ({
  numberOfCreatedCandidates,
  duplicateCandidatesSkipped,
  status,
}: RunStatusCompletedProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <ProgressBar
        value={ 100 }
        color={ status === MatchFlowStatusEnum.Degraded ? '#F1C40F' : 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),#10B981' }
      />
      <Box sx={ style.box.sx }>
        { status === MatchFlowStatusEnum.Completed ? <CheckCircleRounded sx={ style.svg[status] } /> : <CancelRounded sx={ style.svg[status] } /> }
        <div style={ style.textContainer }>
          <Typography variant="overline" sx={ style.typograpyStatus.sx }>
            {translate(status === MatchFlowStatusEnum.Completed ? STRING_KEYS.COMPLETED : STRING_KEYS.DEGRADED)}
          </Typography>
          <Typography variant="caption" sx={ style.typograpyDesc.sx }>
            {translate(STRING_KEYS.CREATED_CANDIDATES)}
            : { numberOfCreatedCandidates }
          </Typography>
          {duplicateCandidatesSkipped !== undefined && (
            <Typography variant="caption" sx={ style.typograpyDesc.sx }>
              {translate(STRING_KEYS.DUPLICATE_CANDIDATES)}
              : {duplicateCandidatesSkipped}
            </Typography>
          )}
        </div>
      </Box>
    </Box>
  );
};

RunStatusCompleted.defaultProps = {
  duplicateCandidatesSkipped: undefined,
};
